import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import "../styles/OrderStyles.css";

const columns = [
  { id: "ProdId", label: "Sr. No", minWidth: "4.11111vw" },
  { id: "ProdName", label: "Product", minWidth: "12.81111vw" },
  { id: "Color", label: "Size", minWidth: "6.11111vw" },
  { id: "Brand", label: "Quantity", minWidth: "6.11111vw" },
  { id: "Pack", label: "Unit", minWidth: "7.11111vw" },
  { id: "Qty", label: "MRP (₹)", minWidth: "3.11111vw" },
  { id: "MRP", label: "Selling Price (₹)", minWidth: "6.11111vw" },
  { id: "SPrice", label: "Amount (₹)", minWidth: "8.11111vw" },
];

function createData(ProdId, ProdName, Color, Brand, Pack, Qty, MRP, SPrice) {
  return { ProdId, ProdName, Color, Brand, Pack, Qty, MRP, SPrice };
}

const rows = [
  createData(
    "1",
    "VKC/3064,VKC,Black",
    "7X9",
    "30",
    "Pair",
    "500",
    "325",
    "9750",
  ),
  createData(
    "2",
    "VKC/3064,VKC,Black",
    "6X9",
    "60",
    "Pair",
    "500",
    "325",
    "19500",
  ),
  createData(
    "3",
    "VKC/3064,VKC,Black",
    "12X10",
    "30",
    "Pair",
    "500",
    "325",
    "9750",
  ),
  createData(
    "4",
    "VKC/3064,VKC,Black",
    "8X10",
    "30",
    "Pair",
    "300",
    "210",
    "6300",
  ),
  createData(
    "5",
    "VKC/3064,VKC,Black",
    "10X12",
    "30",
    "Pair",
    "300",
    "210",
    "6300",
  ),
];

export default function DetailTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const label = { inputProps: { "aria-label": "Color switch demo" } };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div
      style={{
        width: "100%",
        overflow: "hidden",
        marginTop: "2.62596vh",
        padding: "0px 1.22222vw",
      }}>
      <TableContainer
        sx={{ maxHeight: 480, maxWidth: "100%" }}
        className=" overflow-y-scroll no-scrollbar customScrollBar">
        <Table stickyHeader aria-label="sticky table" className="">
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  key={column.id}
                  align="center"
                  sx={{ minWidth: column.minWidth }}
                  style={{
                    backgroundColor: "#EAEAEA",
                    fontWeight: "700",
                    fontSize: "16px",
                  }}
                  className={`${
                    column.id === "SPrice" ? "" : "border-r-2 border-zinc-300"
                  } outfit-semibold`}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map(column => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          sx={{ Width: column.minWidth }}
                          key={column.id}
                          style={{ padding: "10px 0" }}
                          className={`outfit-regular whitespace-nowrap text-ellipsis box-border overflow-hidden w-[${column.minWidth}] h-[4.7vh]`}>
                          <div
                            className={`flex items-center justify-center px-1 ${
                              column.id === "SPrice"
                                ? ""
                                : "border-r-2 border-zinc-400"
                            } font-outfit border-b-0 ${
                              column.id === "ProdId" ||
                              column.id === "Pack" ||
                              column.id === "Qty"
                                ? "text-[#000]"
                                : "text-[#000]"
                            }`}>
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : value}
                          </div>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
